<template>
    <v-form id="searchBar" @submit.prevent="submitSearch">
        <v-row>
            <v-col>
                <v-text-field v-model="searchBarForm.keyword" color="secondary">
                    <template v-slot:label>
                        Search the CTFL corpus
                    </template>
            </v-text-field>
            </v-col>
            <v-col cols='4'>
                <v-autocomplete
                v-model="searchBarForm.country"
                :items="country"
                chips
                label="Country"
                multiple
                ></v-autocomplete>
            </v-col>
            <v-col cols='2'>
                <v-subheader style="height: auto; padding: 0;">Level range</v-subheader>
                <v-range-slider
                    v-model="searchBarForm.levelRange"
                    :max="searchBarForm.levelMax"
                    :min="searchBarForm.levelMin"
                    hide-details
                    class="align-center"
                >
                    <template v-slot:prepend>
                        <v-text-field :value="searchBarForm.levelRange[0]" class="mt-0 pt-0" hide-details single-line type="number" style="width: 50px" @change="$set(searchBarForm.levelRange, 0, $event)">
                        </v-text-field>
                    </template>

                    <template v-slot:append>
                        <v-text-field :value="searchBarForm.levelRange[1]" class="mt-0 pt-0" hide-details single-line type="number" style="width: 50px" @change="$set(searchBarForm.levelRange, 1, $event)">
                        </v-text-field>
                    </template>
                </v-range-slider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols='3'>
                <v-subheader style="height: auto; padding: 0;">Age range</v-subheader>
                <v-range-slider
                    v-model="searchBarForm.ageRange"
                    :max="searchBarForm.ageMax"
                    :min="searchBarForm.ageMin"
                    hide-details
                    class="align-center"
                >
                    <template v-slot:prepend>
                        <v-text-field :value="searchBarForm.ageRange[0]" class="mt-0 pt-0" hide-details single-line type="number" style="width: 50px" @change="$set(searchBarForm.ageRange, 0, $event)">
                        </v-text-field>
                    </template>

                    <template v-slot:append>
                        <v-text-field :value="searchBarForm.ageRange[1]" class="mt-0 pt-0" hide-details single-line type="number" style="width: 50px" @change="$set(searchBarForm.ageRange, 1, $event)">
                        </v-text-field>
                    </template>
                </v-range-slider>
            </v-col>
            <v-col cols='2'>
                <v-subheader class="pa-0" style="height: auto">Sex</v-subheader>    
                <v-layout row class="ml-0"> 
                    <v-checkbox v-model="searchBarForm.sex" class="mr-5 mt-1" label="Female" value="f"></v-checkbox>
                    <v-checkbox v-model="searchBarForm.sex" label="Male" class="mt-1" value="m"></v-checkbox>
                </v-layout>
            </v-col>
            <v-col cols='4'>
                <v-autocomplete
                v-model="searchBarForm.textType"
                :items="textType"
                chips
                label="Text type"
                multiple
                ></v-autocomplete>
            </v-col>
            <v-col cols='1' class="pt-3">
                <v-btn type="submit" form="searchBar" large color="primary" :disabled="loading_queue.length > 0">
                    <span class="d-lg-none"><v-icon>mdi-magnify</v-icon></span>
                    <span class="d-none d-lg-block"><v-icon left>mdi-magnify</v-icon> 
                    <template v-if="!loading_queue.length > 0">
                        Search
                    </template>
                    <template v-else>
                        Loading...
                    </template>
                    </span>
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<style scoped>
.row .col {
    padding-top: 4px;
    padding-bottom: 4px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    name: 'searchBar',
    props: ['searchBarForm', 'country', 'textType'],
    methods: {
        submitSearch: function() {
            if(this.loading_queue.length == 0) {
                this.$router.push({ name: 'search', query: this.searchBarForm })
            }
        }
    },
    computed: {
        ...mapState({
            loading_queue: 'loading_queue'
        })
        // ...mapState({
        //     country: function(state) {
        //         let countryValues = []
        //         for(let c in state.country) {
        //             countryValues.push(state.country[c]['value'])
        //         }
        //         // this.searchBarForm.country = countryValues
        //         this.searchBarForm.countryLoading = false
        //         return state.country
        //     }
        // })
    },
    mounted() {
        // if(this.searchBarForm.country.length == 0) {
        //     this.searchBarForm.country = this.country
        // }
    }
}
</script>